export interface MenuNavPropsContextData {
  isMenuOpen: boolean;
  currentMenuWidth: string;
  handleOpenCloseMenu: () => void;
  setMenuPositionCookie: () => void;
}

export const MenuPositionCookieKey = 'menuPosition';
